export default __webpack_public_path__ + "d998dbb9a6ad9e44a0349fda5ee3202d.svg";